<nav
  class="w-full border-b border-gray-200 bg-white"
  aria-label="Top navigation tabs">

  <div class="flex items-end justify-between">
    @for (tab of tabs; track tab.key) {
      <button
        type="button"
        (click)="selectTab(tab)"
        [disabled]="tab.disabled"
        [attr.aria-selected]="activeKey === tab.key"
        class="relative flex-1 px-4 py-4 text-sm font-semibold
               transition-colors duration-200
               focus:outline-none focus-visible:ring-2
               focus-visible:ring-blue-600 focus-visible:ring-inset
               disabled:cursor-not-allowed disabled:opacity-50"
        [class.text-blue-600]="activeKey === tab.key"
        [class.text-gray-700]="activeKey !== tab.key"
        [class.hover:text-blue-600]="activeKey !== tab.key">

        {{ tab.title }}

        @if (activeKey === tab.key) {
          <span
            class="absolute bottom-0 left-0 h-0.5 w-full bg-blue-600">
          </span>
        }
      </button>
    }
  </div>
</nav>
